import { computed } from 'vue';

import { IconType } from '@/types/icon.types';
import {
  useSharedMenuSearchState,
  useMenuSearchNavigation,
  useMenuSearchFilter,
} from '@/common/components/organisms/menuSearch/menuSearch.uses';
import { createHighlightTextSegments } from '@/common/components/organisms/menuSearch/utils/menuSearch.result.utils';

export interface Props {
  id: string;
  icon: string;
  title: string;
  featuredIcon?: IconType;
  path?: string;
}

export interface Emits {
  (e: 'on-click'): void;
}

export const setup = (props: Props, emit: Emits) => {
  const sharedState = useSharedMenuSearchState();
  const { isMenuSearchItemSelected, selectMenuSearchItem } = useMenuSearchNavigation(sharedState);
  const { debouncedSearchWord } = useMenuSearchFilter(undefined, sharedState);

  const isSelected = computed(() => {
    return isMenuSearchItemSelected(props.id);
  });

  // 하이라이팅 세그먼트 생성
  const highlightSegments = computed(() => {
    if (!debouncedSearchWord.value) {
      return [{ text: props.title, match: false }];
    }
    return createHighlightTextSegments(props.title, debouncedSearchWord.value);
  });

  const handleClick = () => {
    // 아이템 선택
    selectMenuSearchItem(props.id);
    emit('on-click');
  };

  return {
    props,
    isSelected,
    highlightSegments,

    handleClick,
  };
};
